import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    padding-top: 5rem;
    padding-left: 2rem;
    padding-right: 2rem;
    box-sizing: border-box;
    margin-bottom: 5rem;
    @media (max-width: 620px) {
        padding-left: 0;
        padding-right: 0;
        padding-top: 2rem;
    }
`;

